import React from "react";
import { GetGenericAccountsResponse } from "../../../../api/services/client/models";
import {
  ITabs,
  MuiTabPanel,
  MuiTabs,
  MuiTypography,
} from "../../../../components";
import { PAGE_IDS } from "../../../../helpers/constants";
import { useSiteCore } from "../../../../hooks/useSiteCore";
import { createGenericAccounts } from "../../createGenericAccount/siteCore/SiteCoreKeys";
import { GENERIC_ACCOUNT_TAB_INDEX } from "../../editGenericAccountTab/EditGenericAccountTab";
import RegisteredParticipantsTab from "../registeredParticipantsTab/RegisteredParticipantsTab";
import ViewGenericAccountTab from "../viewGenericAccountTab/ViewGenericAccountTab";
import { ViewGenericAccountMainContainer } from "./ViewGenericAccountMain.style";

export const pageId = PAGE_IDS.GENERIC_ACCOUNT_VIEW;

type ViewGenericAccountMainType = {
  data?: GetGenericAccountsResponse;
  currentStep: number;
  setCurrentStep: (step: number) => void;
};

const ViewGenericAccountMain: React.FC<ViewGenericAccountMainType> = ({
  data,
  currentStep,
  setCurrentStep,
}) => {
  const { fetchLabel } = useSiteCore();

  const getLabel = (key: keyof typeof createGenericAccounts) => {
    return fetchLabel(
      createGenericAccounts.createGenericAccountGenericAccountHeaderTitle,
      createGenericAccounts[key],
    );
  };

  const tabIdAccountDetails = `${pageId}-tab1`;
  const tabIdParticipants = `${pageId}-tab2`;
  const tabs: ITabs[] = [
    {
      id: tabIdAccountDetails,
      label: getLabel("genericAccountDetailsTab"),
    },
    {
      id: tabIdParticipants,
      label: getLabel("registeredParticipantsTab"),
    },
  ];

  const onTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setCurrentStep(newValue);
  };

  return (
    <ViewGenericAccountMainContainer>
      <MuiTabs
        tabs={tabs}
        value={currentStep}
        tabsTestIds={[tabIdAccountDetails, tabIdParticipants]}
        onChange={onTabChange}
      >
        <MuiTabPanel
          panelId={`${pageId}-panel1`}
          value={currentStep}
          index={GENERIC_ACCOUNT_TAB_INDEX.GenericAccountDetails}
          isPanelWithMount
          ariaLabelledById={tabIdAccountDetails}
        >
          <MuiTypography>
            <ViewGenericAccountTab data={data} />
          </MuiTypography>
        </MuiTabPanel>
        <MuiTabPanel
          panelId={`${pageId}-panel2`}
          value={currentStep}
          index={GENERIC_ACCOUNT_TAB_INDEX.RegisteredParticipants}
          isPanelWithMount
          ariaLabelledById={tabIdParticipants}
        >
          <MuiTypography>
            <RegisteredParticipantsTab
              data={data}
              isFromEditGenericAccount={false}
            />
          </MuiTypography>
        </MuiTabPanel>
      </MuiTabs>
    </ViewGenericAccountMainContainer>
  );
};

export default ViewGenericAccountMain;
